import React from 'react';
import { connect } from 'react-redux';

import { setVisibilityFilter } from './actions';

const Link = ({active, children, onClick}) => {
  if (active) {
    return <span>{children}</span>;
  }

  return (
    <a href='#'
       onClick={e => {
         e.preventDefault();
         onClick();
       }}
      >
      {children}
    </a>
  );
};

const mapStateProps = (state, ownProps) => {
  return {
    active:
      ownProps.filter ===
      state.visibilityFilter
  };
};

const mapDispatchProps = (dispatch, ownProps) => {
  return {
    onClick: () => {
      dispatch(
        setVisibilityFilter(ownProps.filter)
      );
    }
  };
};

const FilterLink = connect(
  mapStateProps,
  mapDispatchProps
)(Link);

export default () => (
  <div>
    <p>
      View:
      {' '}
      <FilterLink filter='SHOW_ALL'>
        All
      </FilterLink>
      {', '}
      <FilterLink filter='SHOW_ACTIVE'>
        Active
      </FilterLink>
      {', '}
      <FilterLink filter='SHOW_COMPLETED'>
        Completed
      </FilterLink>
    </p>
  </div>
);



/** WEBPACK FOOTER **
 ** ./src/react-todo/Footer.js
 **/